export default __webpack_public_path__ + "static/media/PlayH6.c04fe13c.png";